// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3x6Cw","description":"PatientConsentPreview_description__3l1Ov"};